import BuilderModel from "~/models/tracked/builderModel";
import IRepo from "~/interfaces/repo";
import Repo from "~/state/modules/repo";
import ObjectModelTrigger from "~/models/objectModelTriggers/objectModelTrigger";
import Guid from "~/helpers/guid";
import Vue from "vue";
import PropertyUpdate from "~/models/propertyUpdate";
import {RelationType} from "~/models/relationType";
import {ObjectHelper} from "~/helpers/objectHelper";

export default class RelatedModelUpdate extends BuilderModel {
  except = ['fieldName'];
  property_updates: { [key: string]: PropertyUpdate } = {};
  related_model_id: string;
  static repo: IRepo<RelatedModelUpdate> = new Repo<RelatedModelUpdate>('relatedModelUpdates', RelatedModelUpdate);

  constructor(parent: ObjectModelTrigger, private fieldName: string, json: any = {}) {
    super();
    this.defineProperty('client_id', json['client_id'] || Guid.create());
    this.defineProperty('related_model_id', null);

    this.fieldName = fieldName;
    this.parent = parent;
    this.rootModel = parent.rootModel;
    this.loadFromJson(json, this.rootModel);


    if (this.propertyUpdatesArray.length === 0) {
      this.appendPropertyUpdate()
    }
    RelatedModelUpdate.repo.add(this);
    Vue.set(parent[fieldName], this.client_id, this);
  }

  get rootName(): string {
    return this.fieldName;
  }

  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    const models = {
      'property_updates': {type: PropertyUpdate, relationType: RelationType.dictionary}
    };
    return models;
  }

  createEmbeddedObject = {
    property_updates: (parent, json): PropertyUpdate => new PropertyUpdate(parent, 'property_updates', json),
  };

  appendPropertyUpdate(json = {}) {
    this.createEmbeddedObject.property_updates(this, json)
  }

  get propertyUpdatesArray(): PropertyUpdate[] {
    return ObjectHelper.toArray(this.property_updates)
  }


}